import React, { useMemo } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

const mapContainerStyle = {
  width: "100%",
  height: "100%",
};
const zoom = 2;

const FALLBACK_CENTER = { lat: 39.8283, lng: -98.5795 };
const MAP_SCRIPT_ID = "device-settings-google-map-script";

const getLocationCenter = (location) => {
  const latest = Array.isArray(location) ? location[0] : null;
  const lat = Number(latest?.latitude ?? latest?.lat);
  const lng = Number(latest?.longitude ?? latest?.lng);
  if (Number.isFinite(lat) && Number.isFinite(lng)) {
    return { lat, lng };
  }
  return FALLBACK_CENTER;
};

const GpsTrackingSection = ({ location = [] }) => {
  const center = useMemo(() => getLocationCenter(location), [location]);
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";
  const { isLoaded, loadError } = useJsApiLoader({
    id: MAP_SCRIPT_ID,
    googleMapsApiKey: apiKey,
  });

  if (!apiKey) {
    return <div>Google Maps API key is missing.</div>;
  }

  if (loadError) {
    return (
      <div>
        Unable to load Google Maps. Please disable ad blockers or allow Google
        Maps domains, then retry.
      </div>
    );
  }

  if (!isLoaded) {
    return <div>Loading map...</div>;
  }

  return (
    <GoogleMap mapContainerStyle={mapContainerStyle} zoom={zoom} center={center}>
      <Marker position={center} />
    </GoogleMap>
  );
};

export default GpsTrackingSection;
